<!-- ADD-MODAL-STRUCTURE -->
<div class="master-modal feed_image_modal" role="dialog">
    <div class="modal-dialog">
      <!-- Modal content-->
      <div class="modal-content">
        <!-- Modal-Header -->
        <div class="close-modal">
          <span (click)="dialogClose()" style="color: white;" class="modal-close-icon" ><i class="material-icons">close</i></span>
        </div>
        <!-- Modal content-->
        <div mat-dialog-content>
          <!-- Modal-Body -->
          <div class="modal-body">
            <div class="swiper-container" >
              <div class="swiper-wrapper">

                <div class="swiper-slide" *ngIf="this.data.singleimage ">
                  <img [src]="data?.url" alt="Image">
                </div>

                <div class="swiper-slide" *ngFor="let media of mediaItems">
                  <ng-container *ngIf="media.type === 'image'">
                    <img [src]="media.url" alt="Image">
                  </ng-container>
                  <ng-container *ngIf="media.type === 'video'">
                    <video controls>
                      <source [src]="media.url" type="video/mp4">
                      Your browser does not support the video tag.
                    </video>
                  </ng-container>
                </div>
              </div>
              
          <div *ngIf="hasMultipleMedia && !this.data.singleimage">
              
            <div class="swiper-button-prev swiper-button-disabled" >
            </div>

            <div class="swiper-button-next swiper-button-disabled">
            </div>
          </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
